export const disclaimersandLimitationsofResponsibility = [
  {
    header: "Release of Liability",
    answer:
      "You agree to release HomeSwap from any responsibility for injuries or damages that occur directly or indirectly due to: \n \n \
      • Your use of your property or a Guest Member’s use of your property. \n \
      • Your use of a Host Member’s property. \n  ",
  },
  {
    header: "Scope of Claims",
    answer:
      "This release includes, but is not limited to, claims arising from: \n \n \
        • Injury or Damage: Any injury or damage to persons or property related to property you own. \n \
        • Real Estate Transactions: Claims associated with real estate transactions involving you, including claims from a Guest's guests, even if they are minors. \n \
        • Terms Violations: Any violation of these Terms of Use or the Privacy Policy by you or anyone using your computer or account. \n \
        • Third-Party Rights: Claims that your use of the Platform or that of anyone using your computer or account violates a third party’s rights. \n \
        • Misrepresentation or Misuse: Any misrepresentation made by you or any misuse of the Platform. \n \
        • Interactions with Members: Claims arising from interactions with other Members or their guests, regardless of whether related to the Platform, including breaches of any Exchange or agreements. \n \
        • Legal Violations: Your violation of any applicable laws, rules, or regulations. \n  ",
  },
  {
    header: "Costs and Expenses",
    answer:
      "You agree to cover all costs, damages, and expenses, including reasonable attorneys' fees, related to any claims, suits, actions, or proceedings arising from the above circumstances.",
  },
  {
    header: "Responsibility for User Content",
    answer:
      "Before posting any content, it is up to you to verify if it is protected by copyright, trademark, trade secret, publicity rights, or any other proprietary rights. If the content is not in the public domain or you don't have explicit written permission, do not upload, post, or share it.",
  },
  {
    header: "Permission and Infringement",
    answer:
      "You must have the express permission of the rights holder before sharing content that is protected. If you infringe on copyrights, trademarks, or any other proprietary rights, you will be solely responsible for any damages that arise.",
  },
  {
    header: "Indemnification",
    answer:
      "You agree to indemnify and protect HomeSwap from any claims, losses, or damages resulting from your violation of this section. This includes defending HomeSwap, at its request, from legal consequences due to your actions.",
  },
  {
    header: "No Endorsement or Responsibility",
    answer:
      "HomeSwap does not take responsibility for, endorse, or express any opinion on the conduct, views, or statements shared by Guests, Members, or other users. Your use of the platform and interaction with user-generated content is entirely at your own risk.",
  },
  {
    header: "Right to Revoke Access",
    answer:
      "We reserve the right to revoke your access to the platform at any time if we believe your actions violate laws or harm the interests of HomeSwap or its affiliates.",
  },
  {
    header: "Additional Terms and Clauses",
    answer:
      "You bear full responsibility for any claims, disputes, or damages arising from the violation of third-party agreements or obligations tied to you or your property. This includes—but isn’t limited to—leases, insurance policies, licenses, homeowner association guidelines, condominium or cooperative board rules, and all applicable local or state laws. By participating in HomeSwap, you unconditionally release the platform from any and all claims, whether known or unknown, that stem from such agreements or obligations involving you or your property.",
  },
];
